import React, {FC} from 'react';

import {Anchor} from '../../../../../libs/shared/ui/src/components/reposition/repositionHelpers';
import {SandboxScenariosEnum} from '../../../../helpers/sandbox/sandboxScenarioHelpers';
import {ChatTeammateHandoffEducationTip} from './chatTeammateHandoffEducationTip';
import {SandboxEducationTipCoordinator, useSandboxEndDemoHandler} from './sandboxEducationTipCoordinator';

/*
 * Props.
 */

interface ChatTeammateHandoffEducationTipCoordinatorProps {
  anchor: Anchor;
  conversationId: number | undefined;
}

/*
 * Component.
 */

export const ChatTeammateHandoffEducationTipCoordinator: FC<
  ChatTeammateHandoffEducationTipCoordinatorProps
> = (props) => {
  const onEndDemo = useSandboxEndDemoHandler();

  return (
    <SandboxEducationTipCoordinator
      anchor={props.anchor}
      conversationId={props.conversationId}
      scenario={SandboxScenariosEnum.SCENARIO3_ACT4}
      step="complete-demo"
      isEligible
      EducationTip={ChatTeammateHandoffEducationTip}
      onEnd={onEndDemo}
    />
  );
};
